import { useTranslation } from "react-i18next";
import { Grid, GridColumn, Icon } from "semantic-ui-react";

import { Can } from "components";
import { QuestionResultStatusSelector } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components";
import { getRenderedInterventionPrice } from "modules/AppointmentDetails/components/CustomerCommunicationModal";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";

import type { Intervention } from "models";

type RepairOverviewInterventionItemProps = {
  intervention: Intervention;
  toggleVisibleInPDF: (item: Intervention) => void;
  showVat: boolean;
};

export const RepairOverviewInterventionItem = ({ intervention, toggleVisibleInPDF, showVat }: RepairOverviewInterventionItemProps) => {
  const { t } = useTranslation();

  const selectedLocation = useAppointmentLocation();

  return (
    <div className="Intervention" key={intervention.id}>
      <Grid>
        <GridColumn width={10}>
          <div className="title-container">
            {intervention.question_result_status ? (
              <div className="question-status-container">
                <QuestionResultStatusSelector intervention={intervention} disabled />
              </div>
            ) : null}
            <div className="title-container-button">
              {!intervention.is_local && <Icon className="desktop" size="tiny" />}
              <p>{intervention.title}</p>
            </div>
          </div>
        </GridColumn>
        <GridColumn width={3}>
          {selectedLocation?.dms_price_enabled && (
            <div className="column-container float-right">
              <p>{getRenderedInterventionPrice(intervention, t, showVat, selectedLocation)}</p>
            </div>
          )}
        </GridColumn>
        <Can I="update" the="interventions">
          <GridColumn width={3}>
            <div className="column-container float-right">
              <div className="status-container">
                <div>
                  <Icon
                    className={`eye ${intervention.visible_to_customer ? "green" : "slash red"} pointer`}
                    size="small"
                    onClick={() => toggleVisibleInPDF(intervention)}
                  />
                </div>

                <div>
                  <Icon className={`${intervention.customer_ok ? "check circle green" : "remove circle red"}`} size="large" disabled={true} />
                </div>
              </div>
            </div>
          </GridColumn>
        </Can>
      </Grid>
    </div>
  );
};
